import React from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';

const ArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12,5 19,12 12,19" />
  </svg>
);

const ChoiceTable = () => {
  const { t } = useTranslation('prices');
  const rows = t('table.rows', { returnObjects: true });

  return (
    <div className="ct-section">
      <div className="ct-pattern" aria-hidden="true" />
      <div className="ct-inner">
        <div className="ct-header">
          <span className="ct-header__col">{t('table.ifYouNeed')}</span>
          <span />
          <span className="ct-header__col">{t('table.choose')}</span>
        </div>
        <div className="ct-list">
          {rows.map((row, i) => (
            <div key={i} className="ct-card">
              <span className="ct-card__need">{row.need}</span>
              <span className="ct-card__arrow"><ArrowIcon /></span>
              <span className="ct-card__choose">{row.choose}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChoiceTable;
